<template>
	<div id="app">
		<Admin v-if="loggedIn" />
		<Login v-else />
		<Toasts />
	</div>
</template>

<script>
import Login from '@/views/Login'
import Admin from '@/views/Admin'
import Toasts from '@/components/Toasts'

export default {
	name: 'App',
	computed: {
		loggedIn() {
			return this.$store.getters['auth/loggedIn']
		},
	},
	components: {
		Login,
		Admin,
		Toasts,
	},
	watch: {
		$route(route) {
			console.log(JSON.stringify(route.query))
		}
	}
}
</script>

<style lang="scss">
@import '~scss/vars';
@import '~scss/typography';

html,
body,
#app {
	margin: 0;
	padding: 0;
	overflow: hidden;
	height: 100%;
}

* {
	box-sizing: border-box;
}

hr {
	border: none;
	border-bottom: 1px solid $col-primary;
	margin: 2rem 0;
}
</style>
